import { Addresses } from "lib/graphql-generated";
import { DeepPartial } from "types";

interface Props {
  address: DeepPartial<Addresses>;
  className?: string;
}

export const FormattedAddress = ({ address, className }: Props) => {
  return (
    <>
      <address className={`text-sm text-gray-800 ${className}`}>
        {address.name}
        <br />
        email: {address.contact_email}
        <br />
        contact: {address.phone_number}
        <br />
        {address.line_1}
        <br />
        {address.line_2 && (
          <>
            {address.line_2}
            <br />
          </>
        )}
        {address.line_3 && (
          <>
            {address.line_3}
            <br />
          </>
        )}
        {address.city && (
          <>
            {address.city}
            <br />
          </>
        )}
        <br />
        {address.region && (
          <>
            {address.region}
            <br />
          </>
        )}
        {address.code && (
          <>
            {address.code}
            <br />
          </>
        )}
        {address.country?.name}
      </address>
    </>
  );
};
